import { FormattedMessage } from 'react-intl';
import { Card } from 'ui-components/components/card';
import { Text, TextType } from 'ui-components/components/text';
import { Information } from './components/information';

import { BASE_PRODUCTS_PATH } from '../../../../../routes/constants';
import { messages } from './messages';
import style from './style.module.less';

export const HelpfulLinks = () => {
  return (
    <Card className={style['helpfullinks-section']}>
      <Text textType={TextType.H4} value={<FormattedMessage {...messages.helpfulLinksTitle} />} />
      <Information
        buttonLink='/settings/inventorywarehouses'
        buttonMessage={messages.configureInventoryLocations}
        textMessage={messages.manageInventoryLocations}
      />
      <Information
        buttonLink='/settings/inventorywarehouses'
        buttonMessage={messages.configureTotes}
        textMessage={messages.managePickingTotes}
      />
      <Information buttonLink={BASE_PRODUCTS_PATH} buttonMessage={messages.viewInventory} textMessage={messages.addStockToInformation} />
    </Card>
  );
};
